import { enableAccordions } from "../utils/accordions"

export default function (el) {
	enableAccordions(el)
}
